import { render, staticRenderFns } from "./GameEventMode.vue?vue&type=template&id=21fdcfce&scoped=true&"
import script from "./GameEventMode.vue?vue&type=script&lang=js&"
export * from "./GameEventMode.vue?vue&type=script&lang=js&"
import style0 from "./GameEventMode.vue?vue&type=style&index=0&id=21fdcfce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fdcfce",
  null
  
)

export default component.exports